import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import Button from 'shared/Button';
import { onReset, onMoreTime } from '../actions/timeout';
import Translation from '@checkout-s/Translation';

class TimeoutOverlay extends Component {
    render() {
        return(
            <div className="kiosk__modal">
                <div className="kiosk__modal__content">
                    <div className="kiosk__modal__title">
                       <Translation> {"checkout__do_you_need_more_time"} </Translation>
                    </div>
                    <button className="kiosk-modal__button kiosk-modal__button--primary" onClick={ this.props.onMoreTime }><Translation>{"checkout__yes"}</Translation></button>
                    <button className="kiosk-modal__button kiosk-modal__button--secondary" onClick={ this.props.onReset }><Translation>{"checkout__no"}</Translation></button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        onReset,
        onMoreTime,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(TimeoutOverlay)
